// config/api.js

// Prefer env vars if provided (CRA / Vite / Expo)
const envUrl =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.VITE_API_BASE_URL ||
  process.env.EXPO_PUBLIC_API_BASE_URL;

// Detect if we're in a browser and on a timetab.ch host
const isBrowser = typeof window !== 'undefined';
const onProdHost = isBrowser && /timetab\.ch$/i.test(window.location.hostname);

// Fallback logic:
// - If env var set -> use it
// - Else if on timetab.ch or NODE_ENV=production -> prod URL
// - Else -> local backend
const API_BASE_URL =
  envUrl ||
  (onProdHost || process.env.NODE_ENV === 'production'
    ? 'https://app.timetab.ch'
    : 'http://127.0.0.1:5000');

module.exports = {
  API_BASE_URL,
};
